module.exports = __webpack_public_path__ + "801c0a63a10a987d91b01812e553e761.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/sponsors/svgs.svg
// module id = 52
// module chunks = 0